import React, { useEffect, useState } from "react";
import PieGraph from "../svg-graphs/PieGraph";
import { getFolders, getPopularMenu } from "../../utils/dataFetch";
import ResponsiveTable from "../svg-graphs/ResponsiveTable";

export default function PopularMenu({ startDate, endDate }) {
    const [error, setError] = useState("");
    const [popularMenu, setPopularMenu] = useState([]);

    const [showTable, setShowTable] = useState(false);
    const toggleTable = () => setShowTable(!showTable);

    const [showModalTree, setShowModalTree] = useState(false);

    useEffect(() => {
        const fetchPopularMenu = async () => {
            try {
                const tempStart = new Date(startDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const result = await getPopularMenu(
                    tempStart.toISOString(),
                    tempEnd.toISOString()
                );
                setPopularMenu(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchPopularMenu(startDate, endDate);
    }, [startDate, endDate]);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Популярні страви</h5>
                {error && (
                    <div className="alert alert-danger rounded-5 m-auto">
                        {error}
                    </div>
                )}
                {!error && (
                    <>
                        <div className="mt-3">
                            <PieGraph
                                inputData={popularMenu}
                                legendLabels={["Кількість"]}
                                rowLabel={"Назва"}
                            />
                            {/* Table data */}
                            <div className="d-flex justify-content-center">
                                <button
                                    className="btn btn-sm main--button mt-3 me-1"
                                    onClick={toggleTable}
                                >
                                    {showTable ? "Сховати" : "Показати топ 15"}
                                </button>
                                <button
                                    className="mt-3 btn btn-sm main--button ms-1"
                                    onClick={() => setShowModalTree(true)}
                                >
                                    Всі товари
                                </button>
                            </div>
                            {showTable && (
                                <div className="mt-3">
                                    <ResponsiveTable
                                        data={popularMenu
                                            .sort(
                                                (a, b) =>
                                                    b.values[0] - a.values[0]
                                            )
                                            .slice(0, 15)}
                                        headLabels={["Кількість"]}
                                        rowLabel={"Назва"}
                                    />
                                </div>
                            )}
                            {showTable && popularMenu.length > 10 && (
                                <div className="d-flex justify-content-center mt-3">
                                    <button
                                        className="btn btn-sm main--button"
                                        onClick={toggleTable}
                                    >
                                        Сховати
                                    </button>
                                </div>
                            )}

                            {showModalTree && (
                                <>
                                    <div className="modal--backdrop fade show"></div>
                                    <div
                                        className="modal show"
                                        style={{ display: "block" }}
                                        tabIndex="-1"
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content rounded-5">
                                                <div className="modal-header">
                                                    <h5 className="modal-title ms-0">
                                                        Всі товари
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close me-0"
                                                        onClick={() =>
                                                            setShowModalTree(
                                                                false
                                                            )
                                                        }
                                                    ></button>
                                                </div>
                                                <div className="modal-body">
                                                    <ItemsTree
                                                        productsList={
                                                            popularMenu
                                                        }
                                                    />
                                                </div>

                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm main--button"
                                                        onClick={() =>
                                                            setShowModalTree(
                                                                false
                                                            )
                                                        }
                                                    >
                                                        Закрити
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

const ItemsTree = ({ productsList }) => {
    const [error, setError] = useState("");
    const [folders, setFolders] = useState([]);
    const [products, setProducts] = useState([]);
    const [folderState, setFolderState] = useState({});
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const folderResponse = await getFolders();

                const filteredFolders = folderResponse
                    .filter((folder) => folder.marked === 0)
                    .sort((a, b) => a.name.localeCompare(b.name));

                const filteredProducts = productsList
                    .filter((product) => product.marked === 0)
                    .sort((a, b) => a.label.localeCompare(b.label));

                setFolders(filteredFolders);
                setProducts(filteredProducts);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchData();

        // Dashboard scroll lock when modal window is open
        document.body.classList.add("modal--open");
        return () => {
            document.body.classList.remove("modal--open");
        };
    }, [productsList]);

    const toggleFolder = (folderId) => {
        setFolderState((prevState) => ({
            ...prevState,
            [folderId]: !prevState[folderId],
        }));
    };

    const renderFolders = (parentId) => {
        return folders
            .filter((folder) => folder.parent_id === parentId)
            .map((folder) => (
                <div
                    key={folder.id}
                    className={`folder border rounded-4 p-2 mb-2 ${
                        folderState[folder.id] && "bg-secondary bg-opacity-10"
                    }`}
                >
                    <div
                        className="folder-name"
                        onClick={() => toggleFolder(folder.id)}
                        style={{ cursor: "pointer" }}
                    >
                        <div className={`${folderState[folder.id] && "mb-3"}`}>
                            {folderState[folder.id] ? (
                                <i className="bi bi-folder-minus me-1"></i>
                            ) : (
                                <i className="bi bi-folder-plus me-1"></i>
                            )}{" "}
                            {folder.name}
                        </div>
                    </div>
                    {folderState[folder.id] && (
                        <div
                            className="folder-content"
                            style={{ paddingLeft: "20px" }}
                        >
                            {renderFolders(folder.id)}
                            {renderProducts(folder.id)}
                        </div>
                    )}
                </div>
            ));
    };

    const renderProducts = (parentId) => {
        return products
            .filter((product) => product.parent_id === parentId)
            .map((product) => (
                <div
                    key={product.id}
                    className="product border rounded-4 p-2 mb-2 d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    <div className="me-2">
                        <i className="bi bi-cart3 me-1"></i> {product.label}
                    </div>
                    <span>{product.values[0]}</span>
                </div>
            ));
    };

    const renderSearchResults = () => {
        const filteredProducts = products.filter((product) =>
            product.label.toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (filteredProducts.length === 0) {
            return <p>Немає продуктів...</p>;
        }

        return filteredProducts.map((product) => (
            <div
                key={product.id}
                className="product border rounded-4 p-2 mb-2 d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
            >
                <div className="me-2">
                    <i className="bi bi-cart3 me-1"></i> {product.label}
                </div>
                <span>{product.values[0]}</span>
            </div>
        ));
    };

    return (
        <>
            {error && (
                <div className="alert alert-danger m-auto rounded-5">
                    {error}
                </div>
            )}
            {!error && (
                <div className="folder-tree">
                    <input
                        type="text"
                        placeholder="Пошук продуктів..."
                        className="form-control mb-3 rounded-5 border-secondary"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    {searchTerm ? renderSearchResults() : renderFolders(null)}
                </div>
            )}
        </>
    );
};
